import type { UserContextType } from '@/client/context/user'

export default function isUserInChannel({
  channelId,
  user,
}: {
  channelId: number
  user: UserContextType
}): boolean {
  return user.channelIds.includes(channelId)
}
